


















export default {
  props: ['issue', 'active'],
};

